import { NFTStorage } from "nft.storage";

/**
 * exposes an interface for interaction with ipfs
 */
class IpfsInterface {
  apiKey: string;
  endpoint: string;
  client: NFTStorage;

  constructor(apiKey: string, endpoint: string) {
    this.apiKey = apiKey;
    this.endpoint = endpoint;
    this.client = new NFTStorage({ token: apiKey });
  }

  /**
   * function to upload a file to ipfs via nft.storage
   */
  async upload(data: any): Promise<any> {
    try {
      return await this.client.store(data);
    } catch (e: any) {
      throw new Error(e.toString());
    }
  }
}

export default IpfsInterface;
